/**
 * useCanvasSidebarResize - thin wrapper around shared useSidebarResize.
 *
 * Canvas-specific constants + oversteer enabled.
 * Maps isCollapsed → isSidebarCollapsed for canvasUiStore.
 */

import { useCallback } from 'react';
import { useSidebarResize } from '../../lib/useSidebarResize';
import type { CanvasUiStore } from '../stores/canvasUiStore';

const SIDEBAR_STORAGE_KEY = 'roadmap_2026_canvas_sidebar_width';
const SIDEBAR_COLLAPSED_KEY = 'roadmap_2026_canvas_sidebar_collapsed';
const SIDEBAR_MIN = 180;
const SIDEBAR_MAX = 400;
const SIDEBAR_DEFAULT = 240;
const SIDEBAR_COLLAPSED_WIDTH = 24;
const SIDEBAR_COLLAPSE_THRESHOLD = 100;

export { SIDEBAR_DEFAULT, SIDEBAR_COLLAPSED_WIDTH };

export function useCanvasSidebarResize(uiStore: CanvasUiStore) {
  const onSidebarUpdate = useCallback((patch: { sidebarWidth?: number; isCollapsed?: boolean; isSidebarResizing?: boolean }) => {
    const mapped: Record<string, unknown> = { type: 'sidebar.update' };
    if (patch.sidebarWidth !== undefined) mapped.sidebarWidth = patch.sidebarWidth;
    if (patch.isCollapsed !== undefined) mapped.isSidebarCollapsed = patch.isCollapsed;
    if (patch.isSidebarResizing !== undefined) mapped.isSidebarResizing = patch.isSidebarResizing;
    uiStore.send(mapped as Parameters<typeof uiStore.send>[0]);
  }, [uiStore]);

  return useSidebarResize({
    storageKeyWidth: SIDEBAR_STORAGE_KEY,
    storageKeyCollapsed: SIDEBAR_COLLAPSED_KEY,
    min: SIDEBAR_MIN,
    max: SIDEBAR_MAX,
    defaultWidth: SIDEBAR_DEFAULT,
    collapsedWidth: SIDEBAR_COLLAPSED_WIDTH,
    collapseThreshold: SIDEBAR_COLLAPSE_THRESHOLD,
    oversteer: true,
    onSidebarUpdate,
  });
}
